module.exports = __webpack_public_path__ + "static/media/hot-noodles-ad5.511c9bb1.png";